import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { KeyRound, ArrowRight, ShoppingBag, MessageCircle } from "lucide-react";
import { fetchPack, setCode, getCode, clearCode, errMsg, WA_PACK, WA_HELP } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function Access() {
  const [code, setVal] = useState("");
  const location = useLocation();
  const [error, setError] = useState(location.state?.error || "");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    const saved = getCode();
    if (saved) fetchPack(saved).then(() => nav("/pack", { replace: true })).catch((e) => { clearCode(); setError(errMsg(e)); });
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const data = await fetchPack(code);
      setCode(data.code);
      nav("/pack");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="access-page" className="min-h-screen grid place-items-center px-5 py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="text-2xl" data-testid="access-logo"><Logo /></Link>
        <div className="mt-8 bg-white rounded-lg border border-[var(--sand)] p-6 sm:p-8 shadow-[0_12px_34px_rgba(52,56,50,0.08)]">
          <div className="w-12 h-12 rounded-lg grid place-items-center bg-[var(--sand)]/60 text-[var(--forest)]"><KeyRound /></div>
          <h1 className="font-display text-3xl mt-5">Acceder a mi pack</h1>
          <p className="text-[#5a4f46] mt-2">Escribe el código que te enviamos por WhatsApp.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input
              data-testid="access-code-input"
              value={code}
              onChange={(e) => setVal(e.target.value.toUpperCase())}
              placeholder="CALMA-XXXXX"
              className="w-full rounded-lg border border-[var(--sand)] focus:border-[var(--forest)] outline-none px-4 py-3.5 text-lg tracking-widest font-semibold bg-[var(--cream)]"
              required
            />
            {error && <p data-testid="access-error" className="text-sm text-[#c0392b]">{error}</p>}
            <button data-testid="access-submit-button" disabled={loading} className="btn-accent w-full">
              {loading ? "Entrando…" : <>Entrar <ArrowRight size={18} /></>}
            </button>
          </form>
        </div>
        <div className="mt-6 rounded-lg border border-[var(--sand)] bg-[var(--cream-2)] p-5">
          <p className="font-semibold">¿Aún no tienes tu código?</p>
          <a href={WA_PACK} target="_blank" rel="noreferrer" data-testid="access-buy-button" className="btn-ghost w-full mt-3"><ShoppingBag size={18} /> Comprar curso</a>
        </div>
        <a href={WA_HELP} target="_blank" rel="noreferrer" data-testid="access-help-link" className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold underline"><MessageCircle size={16} /> ¿Problemas con tu código? Escríbenos por WhatsApp</a>
        <p className="text-xs text-[#7a6c5e] mt-3">Al entrar aceptas nuestra <Link to="/privacidad" data-testid="access-privacy-link" className="underline">política de privacidad</Link>.</p>
      </div>
    </main>
  );
}
